/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Page_Verifying_LabelInputs */

const en_login_page_verifying_label = /** @type {(inputs: Login_Page_Verifying_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verifying…`)
};

const de_login_page_verifying_label = /** @type {(inputs: Login_Page_Verifying_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wird bestätigt…`)
};

const pt_br2_login_page_verifying_label = /** @type {(inputs: Login_Page_Verifying_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verificando…`)
};

const tr_login_page_verifying_label = /** @type {(inputs: Login_Page_Verifying_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Doğrulanıyor…`)
};

const zh_cn2_login_page_verifying_label = /** @type {(inputs: Login_Page_Verifying_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在验证…`)
};

const zh_hk2_login_page_verifying_label = /** @type {(inputs: Login_Page_Verifying_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在驗證…`)
};

const ko_kr2_login_page_verifying_label = /** @type {(inputs: Login_Page_Verifying_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`인증 중…`)
};

const ru_ru2_login_page_verifying_label = /** @type {(inputs: Login_Page_Verifying_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Проверяем…`)
};

const es_419_login_page_verifying_label = /** @type {(inputs: Login_Page_Verifying_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verificando…`)
};

/**
* | output |
* | --- |
* | "Verifying…" |
*
* @param {Login_Page_Verifying_LabelInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const login_page_verifying_label = /** @type {((inputs?: Login_Page_Verifying_LabelInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Page_Verifying_LabelInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_login_page_verifying_label(inputs)
	if (locale === "de") return de_login_page_verifying_label(inputs)
	if (locale === "pt-BR") return pt_br2_login_page_verifying_label(inputs)
	if (locale === "tr") return tr_login_page_verifying_label(inputs)
	if (locale === "zh-CN") return zh_cn2_login_page_verifying_label(inputs)
	if (locale === "zh-HK") return zh_hk2_login_page_verifying_label(inputs)
	if (locale === "ko-KR") return ko_kr2_login_page_verifying_label(inputs)
	if (locale === "ru-RU") return ru_ru2_login_page_verifying_label(inputs)
	return es_419_login_page_verifying_label(inputs)
});